import Talk from "talkjs";
import { createContext } from "react";
import { SubscriptionState, SubscriptionTier, User } from "./proto/api_pb";

export interface UserDetailsContextInterface {
  userName: string;
  fullName: string;
  connectedWallet: string;
  storageUsage: number;
  stripeCustomerId: string;
  subscriptionState: number;
  subscriptionTier: number;
  allUsers: User[];
  featuredUsers: User[];
}

export interface S3CredentialsContextInterface {
  awsAccessKeyId: string | undefined;
  awsSecretAccessKey: string | undefined;
  awsSessionToken: string | undefined;
  expiry: number | undefined;
}

export const S3CredentialsContext =
  createContext<S3CredentialsContextInterface>({
    awsAccessKeyId: "",
    awsSecretAccessKey: "",
    awsSessionToken: "",
    expiry: 0,
  });

export const UserDetailsContext = createContext<UserDetailsContextInterface>({
  userName: "",
  fullName: "",
  connectedWallet: "",
  storageUsage: 0,
  stripeCustomerId: "",
  subscriptionState: SubscriptionState.SUBSCRIPTION_STATE_UNSPECIFIED,
  subscriptionTier: SubscriptionTier.SUBSCRIPTION_TIER_UNSPECIFIED,
  allUsers: [],
  featuredUsers: [],
});

export interface AuthContextInterface {
  userId: string;
}

export const AuthContext = createContext<AuthContextInterface>({
  userId: "",
});

export interface TalkJsContextInterface {
  handleChatClick: () => void;
  setParticipants: React.Dispatch<React.SetStateAction<Talk.User[]>>;
  createConversation: (
    conversationId?: string,
    conversationSubject?: string
  ) => void;
  setAutoCreateChat: React.Dispatch<React.SetStateAction<boolean>>;
}

export const TalkJsContext = createContext<TalkJsContextInterface>({
  handleChatClick: () => {},
  createConversation: () => {},
  setParticipants: () => {},
  setAutoCreateChat: () => {},
});
